import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border: 1px solid #000;
  padding: 10px;
  line-height: 1.5;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
`;

const TeacherButton = styled.button`
  flex-basis: calc(16.66% - 10px);
  margin: 5px;
  padding: 10px;
  background-color: ${props => props.buttonColor || '#007bff'};
  color: #ffffff;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  box-sizing: border-box;
  
  @media (max-width: 1024px) {
    flex-basis: calc(25% - 10px);
  }

  @media (max-width: 768px) {
    flex-basis: calc(33.33% - 10px);
  }

  @media (max-width: 480px) {
    flex-basis: calc(50% - 10px);
  }
`;

const TeacherList = ({ teachers }) => {
  const renderTeacherButtons = () => {
    return teachers.map((teacher, index) => (
      <TeacherButton key={teacher.id} buttonColor={getButtonColor(index)}>
        {teacher.teacher}
      </TeacherButton>
    ));
  };

  const getButtonColor = (index) => {
    // You can customize the color logic based on your requirements
    if (index % 3 === 0) {
      return '#007bff'; // Blue
    } else if (index % 3 === 1) {
      return '#28a745'; // Green
    } else {
      return '#dc3545'; // Red
    }
  };

  return (
    <Container>
      {renderTeacherButtons()}
    </Container>
  );
};

export default TeacherList;
